import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" rx="8" fill="#0090FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 3.5C7.44772 3.5 7 3.94772 7 4.5V8.5C7 9.05228 7.44772 9.5 8 9.5C8.55228 9.5 9 9.05228 9 8.5V4.5C9 3.94772 8.55228 3.5 8 3.5ZM8 10.5C7.44772 10.5 7 10.9477 7 11.5C7 12.0523 7.44772 12.5 8 12.5C8.55228 12.5 9 12.0523 9 11.5C9 10.9477 8.55228 10.5 8 10.5Z"
        fill="white"
      />
    </svg>
  );
};

export default Svg;
